import { render, staticRenderFns } from "./index.vue?vue&type=template&id=780dd9b6"
import script from "./billingPlanDetails.js?vue&type=script&lang=js&external"
export * from "./billingPlanDetails.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports